import { Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Permissions } from '@app/core/guard/Permissions';
import { PermissionsService } from '@services/helpers/permissions.service';

/** Motivo da Investigação travada no seletor sem `PARTNERDEALBRIEFINGINVESTIGATION_RUN`. */
export const NO_INVESTIGATION_PERMISSION_HINT = 'Sem permissão para investigar';
/** Dica do Refazer e do Completar investigação sem `PARTNERDEALBRIEFINGINVESTIGATION_RERUN`. */
export const NO_RERUN_PERMISSION_HINT = 'Sem permissão para refazer a investigação';
/** Dica do Gerar e do Tentar de novo sem `PARTNERDEALBRIEFING_GENERATE`. */
export const NO_GENERATE_PERMISSION_HINT = 'Sem permissão para gerar o briefing.';

/** O que a pessoa pode fazer na aba Briefing, uma permissão por ação (as mesmas que a API confere). */
export interface BriefingPermissions {
  /** `PARTNERDEALBRIEFING_GENERATE`: gerar versão nova e tentar de novo a que falhou. */
  canGenerate: Signal<boolean>;
  /** `PARTNERDEALBRIEFING_ADJUST`: pedir ajuste da versão pelo chat do Cog IA. */
  canAdjust: Signal<boolean>;
  /** `PARTNERDEALBRIEFING_SET_CURRENT`: Tornar atual. */
  canSetCurrent: Signal<boolean>;
  /** `PARTNERDEALBRIEFINGINVESTIGATION_VIEW`: ver a caixa da investigação (sem ela a aba nem busca). */
  canViewInvestigation: Signal<boolean>;
  /** `PARTNERDEALBRIEFINGINVESTIGATION_RUN`: marcar a Investigação e as subseções no seletor. */
  canRunInvestigation: Signal<boolean>;
  /** `PARTNERDEALBRIEFINGINVESTIGATION_RERUN`: Refazer investigação e Completar investigação. */
  canRerunInvestigation: Signal<boolean>;
}

/**
 * Lê as permissões da aba Briefing (cards 3878 e 3911). Chamar no contexto de injeção (inicializador de campo do
 * componente). Começam em `false` até a resposta do `PermissionsService`: nenhum botão nasce liberado à toa.
 */
export function readBriefingPermissions(permissions: PermissionsService): BriefingPermissions {
  const read = (permission: string) =>
    toSignal(permissions.hasPermission(permission), { initialValue: false });
  return {
    canGenerate: read(Permissions.PartnerDealBriefing.GENERATE),
    canAdjust: read(Permissions.PartnerDealBriefing.ADJUST),
    canSetCurrent: read(Permissions.PartnerDealBriefing.SET_CURRENT),
    canViewInvestigation: read(Permissions.PartnerDealBriefingInvestigation.VIEW),
    canRunInvestigation: read(Permissions.PartnerDealBriefingInvestigation.RUN),
    canRerunInvestigation: read(Permissions.PartnerDealBriefingInvestigation.RERUN),
  };
}
